// Display-only projection of the immutable Day 1 agreement evidence.
const {travelingExplanation}=require('./travelingExplanation');
const {repeatPairExplanation}=require('./repeatPairExplanation');
function holdExplanation(pick){
 const e=pick.frozenEvidence;
 if(!e?.pairEvidence||!e?.travel||e.family!==pick.family||e.pairEvidence.family!==pick.family||e.travel.family!==pick.family)return null;
 return {travel:travelingExplanation({...pick,frozenEvidence:e.travel}),pair:repeatPairExplanation({...pick,frozenEvidence:e.pairEvidence})};
}
function holdSummary(hold){
 const days=hold?.days||[],straight=days.filter(d=>d.status==='Straight Hit'),box=days.filter(d=>d.status==='Box-only Hit');
 const hits=days.filter(d=>['Straight Hit','Box-only Hit'].includes(d.status)&&typeof d.actual==='string'&&/^\d{3}$/.test(d.actual));
 const last=hits.at(-1);
 return {straight:straight.length,box:box.length,last:last?{day:last.day,number:last.actual,grade:last.status==='Straight Hit'?'STRAIGHT':'BOX'}:null};
}
module.exports={holdExplanation,holdSummary};
